import { render } from "./App.vue?vue&type=template&id=4df40911&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4df40911&lang=css"

import exportComponent from "C:\\GIT\\Greenwheels\\Greenwheels.Vue\\vue-costs-calculator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__